import {BusinessException} from "../../../exceptions/exceptions";

export default class DoubtRules {
  /** Checks if the pill title is empty. */
  static checkEmptyTitle(title: string): BusinessException | void {
    if (!title || !title.trim()) {
      return new BusinessException(
        "Título não pode ser vazio.",
        "EMPTY_FIELD",
        500
      );
    }
  }

  /** Checks if the pill description is empty. */
  static checkEmptyDescription(description: string): BusinessException | void {
    if (!description || !description.trim()) {
      return new BusinessException(
        "Descrição não pode ser vazia.",
        "EMPTY_FIELD",
        500
      );
    }
  }

  /** Checks if an ID is valid.
   * @see id */
  static isNotValidID(id: number | string): BusinessException | void {
    if (typeof id === undefined || isNaN(Number(id))) {
      return new BusinessException("ID não é válido.", "INVALID_ID", 500);
    }
  }
}
